var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isBackgroundGoods)?_c('BackgroundGood',_vm._g(_vm._b({attrs:{"model":_vm.model}},'BackgroundGood',_vm.$attrs,false),_vm.$listeners)):_c('NormalGood',_vm._g(_vm._b({attrs:{"model":_vm.model}},'NormalGood',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }